// Development environment.
// Used by: `ng build --configuration=development`

export const environment = {
  production: false,
  apiUrl: 'https://xi5f-5y62-kbyr.n7e.xano.io',
  aiChatboltBaseUrl: 'https://xtroedge-chatbolt-dev.hf.space',
  // Suggestions endpoint subscription is only active on the production chatbolt
  // server, so always use the prod URL even in development.
  otherConfig: 'devConfig',
  stagingName: ':dev',
  dataSource: 'dev',
  businessBaseUrl: 'https://business-dev.luqta.io',
  contestAppUrl: 'https://contest-dev.luqta.io',
  // Base of the Web QR scan links (/q/<uuid>) — the QR codes always point here,
  // whatever base the report endpoint happens to return.
  webQrAppUrl: 'https://web-luqta.vercel.app',
  webhookPath: '/api:BB6HooOR/luqtaWebhook',
  // Loyalty micro-services gateway (NOT Xano). Single POST /action endpoint.
  // LOCAL microservice (running on localhost:5500).
  // loyaltyApiUrl: 'http://localhost:5500/action'

  loyaltyApiUrl: 'https://luqta-api.xtroedge.com/action'

};
